



























import Vue from 'vue'
import AddonOption from '@/product/components/addonOptions/AddonOption.vue'
import { AddonProduct } from '@/product/types'

export default Vue.extend({
  components: {
    AddonOption
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    addonProducts: {
      type: Array as () => AddonProduct[],
      default: () => []
    },
    selectedAddonProductId: {
      type: String || undefined,
      default: undefined
    },
    outOfStockOptions: {
      type: Object as () => { [key: string]: string },
      required: true
    },
    showHighlightAddonProductSelection: {
      type: Boolean,
      default: false
    }
  }
})
